import { useUrl } from '@packages/shared/src/hooks/useUrl/useUrl';
import { mergeQueryParameters } from '@packages/shared/src/utils/mergeQueryParameters/mergeQueryParameters';
import { searchParamsToObject } from '@packages/shared/src/utils/searchParamsToObject/searchParamsToObject';
import { splitUrl } from '@packages/shared/src/utils/splitUrl/splitUrl';
import { buildUrl } from '@packages/shared/src/utils/buildUrl/buildUrl';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { unmask } from '@packages/gql/src/betterMasking';
import type { UseSearchResultDataForCategoryFilterFragmentFragmentDoc } from '@packages/gql/generated/shopping/UseSearchResultDataForCategoryFilterFragmentFragmentDoc';

import { encodeCategoryFilter } from '@packages/search/src/queryEncoding';

/* GraphQL */ `
  fragment UseSearchResultDataForCategoryFilterFragment on SuccessfulSearchResult {
    categories {
      id
      name
      level
      isSelected
      isSelectedExact
      styleCount
    }
  }
`;

const stripCategory = (searchParams: URLSearchParams) => {
  const adjustedSearchParams = new URLSearchParams(searchParams);
  adjustedSearchParams.delete('c');
  return adjustedSearchParams;
};

// TODO dissolve this hook and move code into component after i18n changes from FETW-14 are merged, with gql changes etc. it is not complex enough anymore to justify a hook
export const useSearchResultDataForCategoryFilter = (
  maskedData: FragmentType<typeof UseSearchResultDataForCategoryFilterFragmentFragmentDoc>,
) => {
  const url = useUrl(true);
  const { pathname, searchParams } = splitUrl(url);
  const paramsObject = searchParamsToObject(searchParams);

  const data = unmask<typeof UseSearchResultDataForCategoryFilterFragmentFragmentDoc>(maskedData);

  return data.categories.map(
    ({ id, name, level, isSelected, isSelectedExact, styleCount }, index) => ({
      id,
      name,
      level,
      isSelected,
      isSelectedExact,
      count: styleCount,
      href:
        index === 0
          ? buildUrl({
              pathname,
              searchParams: stripCategory(searchParams),
            })
          : mergeQueryParameters(pathname, {
              ...paramsObject,
              ...encodeCategoryFilter(id),
            }),
    }),
  );
};
